<template>
  <div class="customer_service">
    <el-dialog title="联系老师" center :visible.sync="customerInfo.showCustomerService" :width="visitSource ==2?'320px':'90%'">
      <div :class="visitSource ==2?'CustomerService_pc':'CustomerService'">
        <div class="container">
          <img v-if="title_url == ''" class="QRteacher" src="./img/QR_teacher.png"/>
          <img v-else class="QRteacher" :src="title_url"/>
          <img v-if="code_url == ''" class="QRcode" src="./img/blxk_code.jpg"/>
          <img v-else class="QRcode" :src="code_url"/>
          <div class="weChartCode">{{contents}}</div>
          <div class="copyBtn" @click='copyText(contents)' :data-text="contents">复制老师微信号</div>
          <div v-if="(tel_phone && tel_phone != '')" class="copyBtn" @click='callPhone(tel_phone)' >
            点击拨打:{{tel_phone}}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import utils from '@/js/utils/util.js';
export default {
  name: 'customer_service',
  props: {
    customerInfo:{
      type:Object,
      value:{
        showCustomerService:false
      }
    }
  },
  data() {
    return {
      // 访问来源 PC:2 或者 H5:3
      visitSource:utils.checkVisitSource(),
      // 微信号
      contents:'bailitopAU',
      // 微信提示图片信息
      title_url: '',
      // 微信二维码地址
      code_url:'',
      // 联系电话
      tel_phone:''
    };
  },
  created() {
    this.initAttached();
  },
  mounted() {
    
  },
  watch:{
    'customerInfo.showCustomerService': function() {
      this.initAttached();
    }
  },
  computed:{
  },
  components: {
  },
  methods: {
    initAttached:function(){
      var customerInfo = this.customerInfo;
      if (customerInfo.initContents) {
        this.contents = customerInfo.initContents;
      }
      if (customerInfo.initCodeUrl) {
        this.code_url = this.GLOBAL.getFileServeUrl() + customerInfo.initCodeUrl;
      }
      if (customerInfo.initTitleUrl) {
        this.title_url = this.GLOBAL.getFileServeUrl() + customerInfo.initTitleUrl;
      }
      if (customerInfo.initPhone) {
        this.tel_phone = customerInfo.initPhone;
      }
//      console.log("this.title_url=============",this.title_url);
//      console.log("this.code_url=============",this.code_url);
    },
    copyText: function (contents) {
      var aux = document.createElement("input"); 
      aux.setAttribute("value", contents); 
      document.body.appendChild(aux); 
      aux.select();
      document.execCommand("copy"); 
      document.body.removeChild(aux);
      alert("复制成功");
    },
    onClose(){
      var customerInfo = this.customerInfo;
      customerInfo.showCustomerService = false;
      this.customerInfo = customerInfo;
    },
    callPhone(tel_phone){
      if (!tel_phone) {
        this.$message("没有电话信息");
        return;
      } else {
        window.location.href = "tel:" + tel_phone;
      }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.CustomerService{height: 360px;width: 280px;margin: 0 auto}
.CustomerService_pc{height: 300px;width: 280px;margin: 0 auto}
.my_close{display: flex;justify-content: flex-end;padding: 5px 5px 0 0;}
.container{display: flex;align-items: center;flex-direction: column}
.copyBtn{width: 220px;height: 32px;text-align: center;line-height: 32px;border-radius: 32px;border: 1px solid #FBC3B2;background: #FEEDE5;color: #F03F01;font-size: 16px;margin: 10px 0 5px 0}
.contactText{color: #656565;font-size: 16px}
.weChartCode{color: #666666;font-size: 14px}
.QRcode{width: 120px;height: 120px}
.QRteacher{width: 240px;height: 70px}
</style>
